import SiteHeader from '../SiteHeader'
import '../Home.css'

const metaItems = [
    '运营者：北京上渔科技有限公司',
    '版本：V1.0',
    '发布日期：2026年7月30日',
    '生效日期：2026年7月30日',
    '联系邮箱：zhangqilin@bjshangyu.com',
]

const policyBlocks = [
    {
        type: 'paragraph',
        text: '北京上渔科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并将按照合法、正当、必要和诚信原则处理您的个人信息。本政策适用于我们通过“上渔APP”向您提供的钓点推荐、鱼情与天气信息、钓鱼知识、鱼类百科、社区互动、群聊、商城、AI钓鱼助手及相关服务。',
    },
    {
        type: 'paragraph',
        text: '请您在使用上渔APP前仔细阅读本政策，尤其是以加粗、提示框等方式标识的内容。涉及敏感个人信息、向第三方提供个人信息或开启特定设备权限时，我们将在具体场景中另行向您告知并依法取得您的单独同意。若您不同意处理非必要个人信息，通常不会影响您使用浏览等基本功能，但相应的个性化或交互功能可能无法使用。',
    },
    { type: 'section', text: '一、我们如何收集和使用个人信息' },
    {
        type: 'paragraph',
        text: '我们仅会为实现明确、合理的产品功能而处理必要的个人信息。不同版本、设备系统和您选择使用的功能可能有所不同。',
    },
    { type: 'subsection', text: '1. 账号注册、登录与账号安全' },
    {
        type: 'paragraph',
        text: '当您使用手机号注册或登录时，我们可能收集手机号码、短信验证码、账号昵称、头像及您主动填写的资料，用于创建账号、验证身份和维护账号安全。',
    },
    {
        type: 'paragraph',
        text: '当您选择微信等第三方账号登录时，经您授权，我们可能从第三方获取公开头像、昵称、OpenID/UnionID等账号标识，用于完成快捷登录和账号绑定。',
    },
    {
        type: 'paragraph',
        text: '为识别异常登录、防范欺诈和保障系统安全，我们可能收集设备型号、操作系统版本、应用版本、网络类型、IP地址、设备标识符、操作日志、崩溃日志及时间戳。设备标识符的具体范围取决于系统权限和实际接入的安全、推送或统计SDK。',
    },
    { type: 'subsection', text: '2. 钓点、天气、鱼情预测与地图服务' },
    {
        type: 'paragraph',
        text: '当您使用附近钓点、当地天气、鱼情预测、地图展示或导航功能时，我们可能处理您的大致位置或精确位置信息。精确位置属于敏感个人信息，我们仅在您主动使用相关功能并授权后处理。',
    },
    {
        type: 'paragraph',
        text: '如您拒绝位置权限，您仍可通过手动选择城市、区域或钓点等方式使用部分服务，但附近推荐和基于实时位置的功能可能受到影响。',
    },
    {
        type: 'paragraph',
        text: '默认情况下，我们不持续收集后台位置。若未来确需为持续导航、行程记录或天气预警在后台处理位置信息，我们会在开启前单独说明目的、方式、范围和必要性，并另行征得您的同意。',
    },
    { type: 'subsection', text: '3. 社区内容、渔获分享与群聊' },
    {
        type: 'paragraph',
        text: '当您发布动态、评论、点赞、收藏、关注、发送群聊消息或上传渔获内容时，我们会处理您主动提交的文字、图片、视频、音频、发布时间、互动记录及相应账号标识。',
    },
    {
        type: 'paragraph',
        text: '当您使用拍照、录像、上传或保存功能时，我们会在获得授权后调用相机、麦克风或系统照片/视频选择器。我们不会因获得相册权限而主动读取与您所选内容无关的文件。',
    },
    {
        type: 'paragraph',
        text: '您发布的昵称、头像和公开内容可能被其他用户查看、评论或分享。请勿在公开内容中上传身份证件、精确住址、联系方式、金融账户或他人的敏感个人信息。',
    },
    { type: 'subsection', text: '4. 商城、订单与支付' },
    {
        type: 'paragraph',
        text: '当您购买商品或服务时，我们可能处理收货人姓名、手机号码、收货地址、订单内容、订单编号、交易金额、配送信息、售后记录和发票信息，以完成下单、配送、售后和客户服务。收货地址和交易信息可能构成敏感个人信息，我们仅在交易所必需的范围内处理。',
    },
    {
        type: 'paragraph',
        text: '支付由微信支付、支付宝或其他持牌支付机构提供时，支付机构将直接处理您的支付账户和交易验证信息。我们通常不会获取您的银行卡密码、支付密码或完整银行卡信息，但会接收支付状态、交易单号和必要的对账信息。',
    },
    { type: 'subsection', text: '5. AI钓鱼助手与个性化推荐' },
    {
        type: 'paragraph',
        text: '当您使用AI钓鱼助手时，我们会处理您主动输入的目标鱼种、水域情况、时间、饵料偏好、问题文本及必要的对话上下文，用于生成钓法、饵料或出钓建议。请勿在输入内容中提交身份证号、金融账户、健康信息等与服务无关的敏感个人信息。',
    },
    {
        type: 'paragraph',
        text: '为向您推荐可能感兴趣的钓点、内容、商品或活动，我们可能基于浏览、搜索、收藏、点赞、关注、购买和粗略位置等记录形成偏好特征。您可通过产品设置关闭个性化推荐；关闭后，我们仍可能提供不基于个人特征的通用内容。',
    },
    {
        type: 'paragraph',
        text: 'AI生成内容仅供参考，受天气、水域变化、数据完整性等因素影响，不构成安全、气象、交通或专业决策承诺。',
    },
    { type: 'subsection', text: '6. 消息通知、活动提醒与客户服务' },
    {
        type: 'paragraph',
        text: '经您授权，我们可能向您发送天气变化、适钓时间、社区互动、群聊、订单状态、系统公告等通知。您可在APP设置或系统设置中关闭通知。',
    },
    {
        type: 'paragraph',
        text: '当您联系我们、申诉、举报或反馈问题时，我们可能处理您的账号信息、联系方式、沟通记录、截图或其他证明材料，用于核实问题、回复请求和保障社区安全。',
    },
    { type: 'subsection', text: '7. 依法无需征得同意的情形' },
    {
        type: 'paragraph',
        text: '在法律法规允许的范围内，履行法定义务或法定职责、订立或履行您作为一方当事人的合同、应对突发公共卫生事件、保护自然人的生命健康和财产安全，或在合理范围内处理您自行公开或其他已合法公开的个人信息等情形，我们可能依法处理您的个人信息而无需另行取得同意。',
    },
    { type: 'section', text: '二、设备权限调用说明' },
    {
        type: 'paragraph',
        text: '设备权限不会默认持续开启。只有在您使用对应功能时，我们才会申请或调用；您可在系统设置中随时关闭。关闭权限不会影响此前基于授权已经进行的处理，但可能导致相关功能不可用。',
    },
    {
        type: 'table',
        columns: ['权限', '使用目的', '调用时机', '说明'],
        rows: [
            ['大致/精确位置', '附近钓点、当地天气、鱼情预测、地图与导航', '使用相关功能时；精确位置需明确授权', '可拒绝，可改为手动选点'],
            ['后台位置', '仅用于经单独说明的持续导航、行程记录或天气预警', '如实际启用须单独告知并同意', '默认不持续收集'],
            ['相机', '拍摄头像、渔获图片或社区视频', '主动拍摄时', '可拒绝，改用相册'],
            ['照片与视频', '选择上传头像、渔获、帖子素材或保存图片', '主动选择或保存时', '优先使用系统照片选择器'],
            ['麦克风', '录制视频、发送语音消息', '主动录音或录像时', '可拒绝，文字功能不受影响'],
            ['通知', '天气、社区、群聊、订单及系统提醒', '首次开启或系统要求时', '可随时关闭'],
            ['蓝牙/附近设备', '连接经确认支持的智能钓鱼设备', '仅在设备配对时', '无相关硬件功能则不应申请'],
            ['存储', '旧版Android读取或保存用户选择的媒体文件', '旧版系统且功能需要时', '新版系统不应申请“管理所有文件”'],
            ['网络状态', '连接服务器、判断网络环境和保障服务稳定', '使用APP期间', '属于基础运行能力'],
        ],
    },
    {
        type: 'note',
        text: '最小必要原则：通讯录、直接拨打电话、安装应用、悬浮窗、修改系统设置、查询全部应用、管理所有文件等高风险权限不应仅因“可能有用”而申请。如安装包中存在上述权限，应逐项确认真实功能依据；无必要场景的，应从应用清单和代码中移除。',
    },
    { type: 'section', text: '三、Cookie及同类技术' },
    {
        type: 'paragraph',
        text: '为保障登录状态、记住设置、分析故障和提升服务安全，我们可能使用Cookie、本地存储、会话标识或同类技术。移动APP通常主要通过本地存储和设备侧标识实现上述目的。您可通过清理缓存、系统设置或退出账号进行管理，但部分操作可能影响登录状态和偏好设置。',
    },
    { type: 'section', text: '四、我们如何委托处理、共享、转让和公开披露个人信息' },
    { type: 'subsection', text: '1. 委托处理' },
    {
        type: 'paragraph',
        text: '我们可能委托云服务、内容审核、短信、客服、物流、数据分析或安全服务提供方处理必要信息。我们会通过协议约定处理目的、期限、方式、信息种类、保护措施及双方权利义务，并对受托人的处理活动进行监督。',
    },
    { type: 'subsection', text: '2. 共享' },
    {
        type: 'paragraph',
        text: '除以下情形外，我们不会向其他个人信息处理者提供您的个人信息：',
    },
    {
        type: 'list',
        items: [
            '获得您的单独同意，或由您主动选择使用第三方功能；',
            '为订立或履行您作为一方当事人的合同所必需，例如向物流服务商提供收件信息；',
            '依据法律法规、诉讼争议解决或行政、司法机关依法提出的要求；',
            '与关联方共享确有必要的信息，并确保其遵守本政策及不低于本政策的保护标准。',
        ],
    },
    { type: 'subsection', text: '3. 转让' },
    {
        type: 'paragraph',
        text: '如发生合并、分立、重组、资产转让、破产清算等导致个人信息转移的情形，我们会向您告知接收方的名称或姓名和联系方式，并要求接收方继续履行本政策及法律规定的义务；如处理目的、方式发生变化，接收方将重新取得您的同意。',
    },
    { type: 'subsection', text: '4. 公开披露' },
    {
        type: 'paragraph',
        text: '除您主动公开发布的内容、取得您的单独同意或法律法规另有规定外，我们不会公开披露您的个人信息。',
    },
    { type: 'section', text: '五、第三方服务与SDK' },
    {
        type: 'paragraph',
        text: '为实现登录、支付、地图、推送、统计、崩溃分析或客服等功能，上渔APP可能接入第三方SDK。第三方可能按照其隐私政策直接处理个人信息。我们会对第三方服务开展必要的安全评估，并在APP内通过《第三方信息共享清单》向您说明第三方名称、处理目的、信息种类、处理方式和隐私政策链接。',
    },
    {
        type: 'table',
        columns: ['服务类型', '提供方/SDK', '目的', '可能处理的信息'],
        rows: [
            ['第三方登录', '微信等（以实际接入为准）', '快捷登录、账号绑定', '昵称、头像、OpenID/UnionID等授权信息'],
            ['第三方支付', '微信支付/支付宝等（以实际接入为准）', '完成订单支付与对账', '订单号、交易金额、支付状态及必要设备/网络信息'],
            ['地图与定位', '待依据安装包确认', '地图展示、钓点、导航、天气定位', '位置、设备与网络信息'],
            ['消息推送', '待依据安装包确认', '天气、社区、群聊、订单通知', '设备标识、推送标识、应用及网络信息'],
            ['统计与崩溃分析', '待依据安装包确认', '统计使用情况、定位故障', '设备/应用信息、日志、网络信息'],
            ['AI服务', '待依据实际供应商确认', '生成钓鱼建议和问答', '用户主动输入内容及必要上下文'],
        ],
    },
    { type: 'section', text: '六、个人信息的存储与跨境' },
    {
        type: 'paragraph',
        text: '存储地点：原则上，我们将在中华人民共和国境内收集和产生的个人信息存储在境内。',
    },
    {
        type: 'paragraph',
        text: '存储期限：我们仅在实现处理目的所必要的最短期限内保存个人信息；法律法规另有强制保存期限的，从其规定。期限届满后，我们将删除或匿名化处理，法律规定或技术上难以删除的，将停止除存储和必要安全保护之外的处理。',
    },
    {
        type: 'paragraph',
        text: '账号注销后：除法律法规要求保留或处理争议所必需的信息外，我们将在合理期限内删除或匿名化处理与账号相关的个人信息。公开内容、交易记录和安全日志可能因履行法定义务而在必要期限内保留。',
    },
    {
        type: 'paragraph',
        text: '跨境提供：目前如无明确跨境业务，我们不会主动将您的个人信息提供至境外。若未来确需跨境提供，我们将依法履行安全评估、个人信息保护认证或订立标准合同等程序，并向您告知境外接收方、处理目的、方式、信息种类和您行使权利的方式，依法取得单独同意。',
    },
    { type: 'section', text: '七、我们如何保护个人信息' },
    {
        type: 'paragraph',
        text: '我们将采取与风险相适应的安全措施，包括身份鉴别、访问控制、最小权限、加密传输、日志审计、数据备份、漏洞管理、员工培训及供应商管理等，努力防止个人信息遭到未经授权的访问、泄露、篡改、丢失或滥用。',
    },
    {
        type: 'paragraph',
        text: '如发生或可能发生个人信息泄露、篡改、丢失，我们将立即采取补救措施，并依法向履行个人信息保护职责的部门报告；法律规定需要通知个人的，我们将通过站内信、推送、短信、邮件或公告等方式告知事件情况、可能影响、已采取或将采取的措施、您的防范建议及我们的联系方式。',
    },
    {
        type: 'paragraph',
        text: '互联网环境并非绝对安全。请妥善保管账号和验证码，不要向他人披露密码、支付凭证或其他验证信息。',
    },
    { type: 'section', text: '八、您的个人信息权利' },
    {
        type: 'paragraph',
        text: '在法律法规规定的范围内，您对个人信息享有知情、决定、限制或拒绝处理、查阅、复制、更正、补充、删除、撤回同意、注销账号，以及要求解释处理规则等权利。',
    },
    {
        type: 'table',
        columns: ['权利', '行使方式'],
        rows: [
            ['查阅、更正和补充', '通过“我的/个人资料/设置”等入口管理昵称、头像及账号资料；无法自行处理的，可发送邮件联系我们。'],
            ['复制或转移', '可申请获取依法可复制的信息；符合法定条件的，我们将提供转移途径。'],
            ['撤回同意', '在系统权限设置、APP设置或具体功能入口关闭授权。撤回不影响撤回前基于同意进行的处理。'],
            ['删除', '可删除您发布的内容或申请删除不再必要、违法处理或撤回同意后的个人信息。'],
            ['账号注销', '通过APP内注销入口办理；如暂未提供入口，可通过联系邮箱申请，我们将在核验身份后处理。'],
            ['个性化推荐管理', '通过APP设置关闭个性化推荐；关闭后仍可能展示通用内容。'],
            ['投诉与申诉', '通过APP反馈入口或联系邮箱提交，我们通常将在15个工作日内答复。'],
        ],
    },
    {
        type: 'paragraph',
        text: '为保障账号与信息安全，我们可能要求您进行必要的身份验证。对于无端重复、需要过多技术手段、可能损害他人合法权益或法律法规规定无需响应的请求，我们可能依法拒绝，并向您说明理由。',
    },
    { type: 'section', text: '九、未成年人个人信息保护' },
    {
        type: 'paragraph',
        text: '上渔APP主要面向具备相应民事行为能力的用户。若您未满18周岁，应在监护人指导下阅读并使用本服务；若您未满14周岁，请在取得监护人同意后使用，并由监护人帮助完成相关授权。',
    },
    {
        type: 'paragraph',
        text: '我们不会明知故意收集未满14周岁未成年人的个人信息而不取得其监护人同意。如我们发现存在未经有效同意处理儿童个人信息的情形，将尽快删除或采取其他必要措施。监护人如需查询、更正或删除未成年人的信息，可通过本政策所列联系方式与我们联系。',
    },
    { type: 'section', text: '十、本政策如何更新' },
    {
        type: 'paragraph',
        text: '我们可能根据服务变化、法律法规要求或安全需要更新本政策。对于重大变更，我们会通过弹窗、页面提示、站内信、推送或其他显著方式向您告知；如变更涉及处理目的、方式、个人信息种类或对您权益有重大影响，我们将依法重新取得同意。未经您明确同意，我们不会削减您依据本政策享有的权利。',
    },
    { type: 'section', text: '十一、如何联系我们' },
    { type: 'paragraph', text: '个人信息处理者：北京上渔科技有限公司' },
    { type: 'paragraph', text: '应用名称：上渔APP' },
    { type: 'paragraph', text: '联系邮箱：zhangqilin@bjshangyu.com' },
    {
        type: 'paragraph',
        text: '如您对本政策、个人信息处理活动或您的权利有任何问题、意见、投诉或举报，可通过上述邮箱联系我们。我们将在收到请求并完成必要身份核验后尽快处理，通常不超过15个工作日。',
    },
    {
        type: 'paragraph',
        text: '如您对我们的答复不满意，您还可以向履行个人信息保护职责的部门投诉举报，或依法向有管辖权的人民法院提起诉讼。',
    },
]

function renderBlock(block, index) {
    if (block.type === 'section') {
        return <h2 key={index}>{block.text}</h2>
    }

    if (block.type === 'subsection') {
        return <h3 key={index}>{block.text}</h3>
    }

    if (block.type === 'list') {
        return (
            <ul key={index}>
                {block.items.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        )
    }

    if (block.type === 'table') {
        return (
            <div className="sy-policy__table-wrap" key={index}>
                <table>
                    <thead>
                        <tr>
                            {block.columns.map((column) => (
                                <th key={column}>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {block.rows.map((row) => (
                            <tr key={row.join('|')}>
                                {row.map((cell) => (
                                    <td key={cell}>{cell}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }

    if (block.type === 'note') {
        return (
            <p className="sy-policy__note" key={index}>
                {block.text}
            </p>
        )
    }

    return <p key={index}>{block.text}</p>
}

function Privacy() {
    return (
        <div className="sy-home">
            <SiteHeader />
            <main className="sy-policy">
                <article className="sy-container sy-policy__article">
                    <a className="sy-policy__back" href="/">
                        返回首页
                    </a>
                    <header className="sy-policy__head">
                        <p className="sy-policy__kicker">上渔APP</p>
                        <h1 className="sy-display">隐私政策</h1>
                        <dl className="sy-policy__meta">
                            {metaItems.map((item) => {
                                const [label, value] = item.split('：')
                                return (
                                    <div key={item}>
                                        <dt>{label}</dt>
                                        <dd>{value}</dd>
                                    </div>
                                )
                            })}
                        </dl>
                    </header>
                    <div className="sy-policy__content">
                        {policyBlocks.map(renderBlock)}
                    </div>
                </article>
            </main>
        </div>
    )
}

export default Privacy
